import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
/**
 * Import components
 */
import Login from '../components/Login';
import CheckIn from '../components/pre-registration/CheckIn';
import CheckInLink from '../components/pre-registration/CheckInLink';
import UploadPhoto from '../components/pre-registration/UploadPhoto';
import PersonalInfo from '../components/pre-registration/PersonalInfo';
import InsuranceData from '../components/pre-registration/InsuranceData';
import InsuranceCard from '../components/pre-registration/InsuranceCard';
import ContactInfo from '../components/pre-registration/ContactInfo';
import AddressInfo from '../components/pre-registration/AddressInfo';
import EmergencyContact from '../components/pre-registration/EmergencyContact';
import MedicalDecisionMaker from '../components/pre-registration/MedicalDecisionMaker';
import PrimaryCarePhysician from '../components/pre-registration/PrimaryCarePhysician';
import ReferringProvider from '../components/pre-registration/ReferringProvider';
import Questionnaire from '../components/pre-registration/Questionnaire';
import SignDocuments from '../components/pre-registration/SignDocuments';
import ThankYou from '../components/pre-registration/ThankYou';
import UpdateInfo from '../components/UpdateInfo';
import Insurance from '../components/pages/Insurance';

const parseToken = function (token = '') {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
};

/**
 * Protect routes from not authenticated user
 */
const protectAuth = (to, from, next) => {
  let pt = sessionStorage.getItem('patientApiToken'),
      pn = sessionStorage.getItem('patientNumber'),
      authSource = sessionStorage.getItem('authSource');

  if (authSource) {
    if (pn === to.params.patientNumber && authSource === 'bookonline') {
      next();
    }
  } else {
    if (pt) {
      const token = parseToken(sessionStorage.getItem('patientApiToken'));

      if (token.patient_number === to.params.patientNumber) {
        next();
      }
    }
  }
};

/**
 * Protect routes from patient without authentication (pre-registaration)
 */
const protectPatientAuth = (to, from, next) => {
  const patientToken = sessionStorage.getItem('patientApiToken');
  if (patientToken) {
    if (parseToken(patientToken).patient_number === to.params.patientNumber) {
      next();
    }
  } else {
    next({
      name: 'CheckIn',
      params: { pid: null }
    })
  }
};

const routes = [
  {
    path: '/update-info/:patientNumber/:token?/:tab?',
    component: UpdateInfo,
    name: 'UpdateInfo',
    beforeEnter: protectAuth
  },
  {
    path: '/:patientNumber/update/:type?',
    component: Insurance,
    name: 'Insurance',
    beforeEnter: protectAuth
  },
  {
    path: '/:patientNumber/thank-you/',
    component: ThankYou,
    name: 'ThankYou',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/sign-documents/',
    component: SignDocuments,
    name: 'SignDocuments',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/questionnaire/',
    component: Questionnaire,
    name: 'Questionnaire',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/referring-provider/',
    component: ReferringProvider,
    name: 'ReferringProvider',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/primary-care-physician/',
    component: PrimaryCarePhysician,
    name: 'PrimaryCarePhysician',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/medical-decision-maker/',
    component: MedicalDecisionMaker,
    name: 'MedicalDecisionMaker',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/emergency-contact/',
    component: EmergencyContact,
    name: 'EmergencyContact',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/address-info/',
    component: AddressInfo,
    name: 'AddressInfo',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/contact-info/',
    component: ContactInfo,
    name: 'ContactInfo',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/insurance-card/',
    component: InsuranceCard,
    name: 'InsuranceCard',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/insurance-data/',
    component: InsuranceData,
    name: 'InsuranceData',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/personal-info/',
    component: PersonalInfo,
    name: 'PersonalInfo',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:patientNumber/upload-photo/',
    component: UploadPhoto,
    name: 'UploadPhoto',
    beforeEnter: protectPatientAuth
  },
  {
    path: '/:pir/:token?/:tab?',
    component: Login,
    name: 'Login'
  },
  {
    path: '/:pid',
    component: CheckIn,
    name: 'CheckIn'
  },
  {
    path: '/:epn',
    component: CheckInLink,
    name: 'CheckInLink',
    meta: {
      title: 'Online Pre-Check In',
      completeTitle: 'Thank you.\n' +
          'You have completed the pre-check in process.',
      completeMessage: 'If you have any questions, please contact our care team at',
      completePhone: '(855) 444-5975'
    },
  },
];

export default new VueRouter({
  routes
});
